import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, navigate] = useLocation();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-destructive" />
            <h1 className="text-2xl font-bold text-foreground"><FormattedMessage id="pages.notFound.title" /></h1>
          </div>

          <p className="mt-4 text-sm text-muted-foreground">
            <FormattedMessage id="pages.notFound.description" />
          </p>

          <div className="flex gap-3 mt-6">
            <Button variant="outline" onClick={() => window.history.back()}>
              <FormattedMessage id="common.actions.back" />
            </Button>
            <Button onClick={() => navigate("/")}>
              <FormattedMessage id="pages.notFound.goHome" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

